import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { format } from "d3-format"
import CvdMikroCardssmall from '../../../../../components/Cards/CVDMikroCards_small';
import DiaOverview from "../InfoText/DiaOverview";
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import DiaHeaderMicro from './DiaHeaderMicro';


const micro_warning_low = 153;
const micro_warning_red = 115;


export default function MICROCARD(data) {

const diversity = data.data

return (
<>
<CvdMikroCardssmall  
  
content = {<>      

   <Grid container  sx={{p:2}}>   
            
        
                <Grid size={10}> <DiaHeaderMicro />   </Grid>
                <Grid size={2} > <DiaOverview/>   </Grid>

        <Grid size={6} sx={{mt:2, pl:1, pt:2 }} >
                <Typography   variant="h3" color='primary.light' gutterBottom
                            sx={{fontFamily: 'Poppins', fontWeight: '400', fontSize: {xs: '200%', sm: '220%', md: '220%', lg: '240%', xl: '240%' },
                                    
                                    color: 'traffic.green', 
                                    ...(diversity < micro_warning_low && {color: 'traffic.orange'}), 
                                    ...(diversity < micro_warning_red && {color: 'traffic.red'}), 
                                    }}> 
                            
                            {format(",")(diversity )}&nbsp;<Typography component="span" variant="body1"> species </Typography><br />
                            
                </Typography>
                <Typography variant='h6 'sx={{  color: 'common.white', fontFamily: 'Poppins', fontWeight: '200', fontSize: '0.8rem'}} >
            Reference:  &nbsp;  150 {'-'} 340
        </Typography>
            </Grid>

            <Grid size={6} sx={{mt:3, p:2}}>  

            <Typography   variant="h5" sx={{color: 'primary.light', fontWeight: '600'}}>Entero Typ: 1</Typography> 
             </Grid>

        <Grid size={12} sx={{mt:4, pl:1,  pt:1 }} > 
            
        </Grid>
                
            

            <Grid size={5} sx={{ mt:4 }} >
                <Gauge width={160} height={170} value={70} startAngle={-140} endAngle={140}
                        sx={(theme) => (
                            { 
                            [`& .${gaugeClasses.valueText}`]: {  fontSize: 24, transform: 'translate(0px, 0px)', },
                            [`& .${gaugeClasses.valueText} text`]: {fill: theme.palette.common.white }, // <-- change text color
                            [`.MuiGauge-referenceArc`]: { fill: theme.palette.background.grey,},
                            [`& .${gaugeClasses.valueArc}`]: {fill: theme.palette.traffic.green, }, 
                            [`& .${gaugeClasses.root}`]: {  },
                            } ) }
                        text={ ({ value, valueMax }) => `${value} / ${valueMax}`}
                />
        </Grid>

        <Grid size={6} sx={{mt:4,  pl:6, }} >
            <Typography   variant="h6" sx={{color: 'primary.light', fontWeight: '600'}}>Overall Score: </Typography> 
            <Typography   variant="body2" sx={{color: 'primary.light'}}>middle 50% of reference population</Typography>   

            <Typography   variant="h6" sx={{mt:2, color: 'primary.light', fontWeight: '600'}}>Review Areas: </Typography> 
            <Typography   variant="body2" sx={{color: 'primary.light'}}>14 out of 23</Typography>  

            <Typography   variant="h6" sx={{mt:2, color: 'primary.light', fontWeight: '600'}}>Most Detrimental: </Typography> 
            <Typography   variant="body2" sx={{color: 'primary.light'}}>Evenness</Typography>             

        </Grid>
          
    </Grid>
           
        </>}   
    />    
    </>
    )};
  